import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

const Container: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
};

const ContentContainer: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`w-full max-w-[1024px] mx-auto px-6 ${className}`}>
      {children}
    </div>
  );
};

const CalendarContainer: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`w-full max-w-[800px] mx-auto px-6 my-8 relative ${className}`}>
      {children}
    </div>
  );
};

// Grid containers using Tailwind classes
const GridContainer: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`grid grid-cols-[minmax(1.5rem,1fr)_minmax(0,1200px)_minmax(1.5rem,1fr)] ${className}`}>
      {children}
    </div>
  );
};

const GridContent: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`col-start-2 col-end-3 ${className}`}>
      {children}
    </div>
  );
};

const GridFullBleed: React.FC<ContainerProps> = ({ children, className = '' }) => {
  return (
    <div className={`col-span-full ${className}`}>
      {children}
    </div>
  );
};

export { Container, ContentContainer, CalendarContainer, GridContainer, GridContent, GridFullBleed }; 